<template>
  <b-modal
    id="ship-to-currency-modal"
    hide-footer
    hide-header
    centered
    @show="syncFromProps"
  >
    <div class="tw-p-2">
      <h3 class="tw-mb-1 tw-text-center tw-text-xl tw-font-bold tw-text-slate-900">
        {{ $l('shipTo') }}
      </h3>
      <p class="tw-mb-5 tw-text-center tw-text-sm tw-text-slate-500">
        {{ $l('shipToHint') }}
      </p>

      <section class="tw-mb-6">
        <h4 class="tw-mb-3 tw-text-sm tw-font-semibold tw-text-slate-900">{{ $l('shipTo') }}</h4>
        <div class="tw-grid tw-max-h-48 tw-grid-cols-1 tw-gap-2 tw-overflow-y-auto sm:tw-grid-cols-2">
          <button
            v-for="country in shipToCountries"
            :key="country.code"
            type="button"
            class="tw-flex tw-items-center tw-gap-3 tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-3 tw-text-sm tw-text-slate-700 tw-transition-colors hover:tw-border-brand"
            :class="{ 'tw-border-brand tw-bg-brand-soft tw-text-brand-dark': draftCountry === country.code }"
            @click="draftCountry = country.code"
          >
            <img class="tw-h-4 tw-w-6 tw-rounded-[2px] tw-object-cover" :src="'/img/flags/' + country.code + '.png'" alt="">
            <span>{{ countryLabel(country) }}</span>
          </button>
        </div>
      </section>

      <section class="tw-mb-6">
        <h4 class="tw-mb-3 tw-text-sm tw-font-semibold tw-text-slate-900">{{ $l('currency') }}</h4>
        <div class="tw-grid tw-grid-cols-2 tw-gap-2">
          <button
            v-for="currency in currencies"
            :key="currency.code"
            type="button"
            class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-3 tw-text-sm tw-font-medium tw-text-slate-700 tw-transition-colors hover:tw-border-brand"
            :class="{ 'tw-border-brand tw-bg-brand-soft tw-text-brand-dark': draftCurrency === currency.code }"
            @click="draftCurrency = currency.code"
          >
            <span class="tw-text-lg">{{ currency.sign }}</span>
            <span>{{ currencyLabel(currency) }}</span>
          </button>
        </div>
      </section>

      <button type="button" class="tw-primary-button tw-w-full" @click="apply">
        {{ $l('apply') }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import { SHIP_TO_COUNTRIES, SUPPORTED_CURRENCIES } from '@/data/shippingPreferences';

export default {
  name: 'ShipToCurrencyModal',
  props: {
    selectedCountry: {
      type: String,
      default: 'US',
    },
    selectedCurrency: {
      type: String,
      default: 'USD',
    },
  },
  data() {
    return {
      shipToCountries: SHIP_TO_COUNTRIES,
      currencies: SUPPORTED_CURRENCIES,
      draftCountry: 'US',
      draftCurrency: 'USD',
    };
  },
  methods: {
    syncFromProps() {
      this.draftCountry = this.selectedCountry || 'US';
      this.draftCurrency = this.selectedCurrency || 'USD';
    },
    countryLabel(country) {
      return this.locale === 'he' ? country.nameHe : country.nameEn;
    },
    currencyLabel(currency) {
      return this.locale === 'he' ? currency.nameHe : currency.nameEn;
    },
    apply() {
      this.$emit('apply', {
        country: this.draftCountry,
        currency: this.draftCurrency,
      });
      this.$bvModal.hide('ship-to-currency-modal');
    },
  },
};
</script>
